module.exports = __webpack_public_path__ + "e3a20cc3.webp";